<template>
    <div>

        <vue-headful :title="__('incidents.label_plural') + ' :: MeritEHS'"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-stethoscope"></i> {{ __('incidents.label_plural') }}</li>
                <li class="ml-3">
                    <router-link :to="`/incidents/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> {{ __('general.create') }}</router-link>
                </li>
            </ol>
        </h4>

        <saved-filter-title :filterKey="'incidentFilters'" />

        <div class="card">
            <div class="card-body">
                <incident-list ref="incidentIndexList" :allowFilterSaving="true" :filterId="(filter_id ? parseInt(filter_id) : null)" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filter_id: this.$route.query.filter_id,
            }
        },

        computed: {
            appliedFilter(){
                return this.$store.state.appliedFilter;
            }
        },

        methods: {
            setUpdateFilter(){
                //Set it
                this.$store.commit('setUpdateFilter', true);
            },

            setDeleteFilter(){
                //Set it
                this.$store.commit('setDeleteFilter', true);
            },

            removeFilter(){
                //Clear the filters?
                this.$refs.incidentIndexList.filtersCleared();

                //Set it
                this.$router.push('/incidents');
            }
        },

        mounted(){
            //Focus on the SEarch Input
            this.$refs.incidentIndexList.$refs.incidentTable.$refs.genericFilter.focus();
        },
    }
</script>
